<div class="modal-header w-100 mb-4 padding-0">
  <p-breadcrumb [model]="data.items"></p-breadcrumb>
  <i class="close btn-close" (click)="onNoClick()"></i>
</div>
<div class="popup-container-pd--wrapper">
  <div class="popup-container-pd--gallery">
    <swiper
      style="
        --swiper-navigation-color: #b5b5c3;
        --swiper-pagination-color: #b5b5c3;
      "
      [loop]="false"
      [spaceBetween]="10"
      [navigation]="true"
      [thumbs]="{ swiper: thumbsSwiper }"
      class="product-main-swiper"
    >
      <ng-template swiperSlide *ngFor="let img of productDetail.mainImagePath">
        <img
          [src]="imageEndPoint + img.imagePath"
          onError="this.src='assets/Images/noImg.png';"
        />
      </ng-template>
    </swiper>

    <swiper
      (swiper)="thumbsSwiper = $event"
      [loop]="false"
      [spaceBetween]="20"
      [slidesPerView]="4"
      [freeMode]="true"
      [watchSlidesProgress]="true"
      class="product-thumbs-swiper"
    >
      <ng-template swiperSlide *ngFor="let img of productDetail.mainImagePath">
        <img
          [src]="imageEndPoint + img.imagePath"
          onError="this.src='assets/Images/noImg.png';"
        />
      </ng-template>
    </swiper>
  </div>
  <div class="popup-container-pd--rightContainer popup-container-pd--info">
    <div class="popup-title-pd ">
      {{ productDetail.name }}
    </div>
    <div *ngIf="data.catalog" [className]="data.catalog ? 'border-desc' : ''">
      <div class="popup-container-pd--info">
        <div class="contracts-title-container popup-label-field">
          <span class="material-symbols-outlined">history_edu</span>Related
          Contracts:
        </div>
        <div
          class="item-wrap supplier-title"
          *ngFor="let contract of productDetail.RelatedContracts"
        >
          <img
            [src]="imageEndPoint + contract.RelatedContractLogo"
            onError="this.src='assets/Images/noImg.png';"
            class="img-supplier"
          />
          {{ contract.RelatedContract }}
        </div>
        <p *ngIf="productDetail.RelatedContract === []" class="contracts-p">
          Not assigned to any contracts yet!
        </p>
      </div>
    </div>
    <div class="popup-container-pd--info popup-label-field max-pd-content">
      <div>Description:</div>
      <p>
        {{ productDetail.description }}
      </p>
    </div>
    <div class="popup-container-pd--info border-desc">
      <div>
        <span class="popup-label-field"> Product Unit: </span>
        <span class="popup-label-field-desc">
          {{ productDetail.unitCode }}
        </span>
      </div>
      <div>
        <span class="popup-label-field"> Unit Hint: </span>
        <span class="popup-label-field-desc">
          {{ productDetail.unitHint }}
        </span>
      </div>
      <div>
        <span class="popup-label-field"> Storage Condition: </span>
        <span class="popup-label-field-desc">
          {{ productDetail.storageCondition }}
        </span>
      </div>
      <div>
        <span class="popup-label-field"> Package Type: </span>
        <span class="popup-label-field-desc">
          {{ productDetail.packageType }}
        </span>
      </div>
    </div>
    <div
      [className]="
        productDetail.nutritionalFacts.length > 0
          ? 'popup-container-pd--info border-desc'
          : ''
      "
    >
      <div *ngIf="productDetail.nutritionalFacts.length > 0">
        <div class="popup-label-field">Nutration Facts:</div>
      </div>

      <div *ngIf="productDetail.nutritionalFacts.length !== 0">
        <div
          class="product-details-sidebar--product-nutritional-facts-item"
          *ngFor="let fact of productDetail.nutritionalFacts"
        >
          <div
            class="product-details-sidebar--product-nutritional-facts popup-label-field-desc"
          >
            {{ fact.name }}
          </div>
          <div
            class="product-details-sidebar--product-nutritional-facts popup-label-field-desc"
          >
            {{ fact.value }}
          </div>
        </div>
      </div>
    </div>
    <div class="popup-price-container w-100">
      <div
        *ngIf="data.cost > 0 && (data.sales || data.catalog)"
        class="popup-price-content"
      >
        <div class="popup-price-content__title">Cost:</div>
        <div class="popup-price-content_price">
          {{
            data.cost | currency : userDetailsService.user.currencyCode + " "
          }}
        </div>
        <div class="popup-price-content__hint">{{ data.product.unitHint }}</div>
      </div>

      <div
        *ngIf="
          (data.discountPrice === data.originalPrice ||
            (data.discountPrice === 0 && data.originalPrice > 0)) &&
          !data.catalog
        "
        class="popup-price-content"
      >
        <div class="popup-price-content__title">Price:</div>
        <div class="popup-price-content_price">
          {{
            data.originalPrice
              | currency : userDetailsService.user.currencyCode + " "
          }}
        </div>
        <div class="popup-price-content__hint">{{ data.product.unitHint }}</div>
      </div>
      <div
        *ngIf="data.discountPrice < data.originalPrice"
        class="popup-price-content"
      >
        <div class="popup-price-content__title">Price:</div>
        <div class="popup-price-content_price--discount">
          {{
            data.originalPrice
              | currency : userDetailsService.user.currencyCode + " "
          }}
        </div>
        <div class="popup-price-content_price">
          {{
            data.discountPrice
              | currency : userDetailsService.user.currencyCode + " "
          }}
        </div>
        <div class="popup-price-content__hint">{{ data.product.unitHint }}</div>
      </div>
    </div>
  </div>
</div>
